<div id="b-header" [class.breadcrumb-electron-mac]="resizeManager.isMacApp" *ngIf="((!resizeManager.isPortrait && breadcrumbSrv.hideOnSmallDevices) || !breadcrumbSrv.hideOnSmallDevices) && !breadcrumbSrv.isHidden">
  <div>
    <div class="hover-bttn" (click)="back()" *ngIf="menuSrv.showNavigation">
      <ion-icon name="fa-arrow-left" style="color: var(--text);"></ion-icon>
    </div>

    <div class="breadcrumbs">
      <div class="breadcrumb"  *ngFor="let breadcrumb of breadCrumbs" (click)="breadcrumb?.action ? breadcrumb?.action() : null " [class.hide]="!breadcrumb.name">
        <div [title]="breadcrumb.name">{{breadcrumb.name}}</div>
        <div class="breadcrumb-seperator"*ngIf="breadcrumb.name">/</div>
        
      </div>
    </div>
  </div>
  <div>
    <div class="hover-bttn bttn-fullscreen" *ngFor="let bttn of fullscreenButtons" (click)="bttn.action($event)" [hoverTitle]="{text: bttn?.title, position: 'bottom'}">
      <ion-icon *ngIf="bttn?.ionIcon" [name]="bttn?.ionIcon"></ion-icon>
      <div *ngIf="bttn?.svg" [innerHtml]="bttn?.svg | safeHtml : true"></div>
    </div>
  </div>
</div>